import React from 'react';

import IconButton from 'components/IconButton';
import MonthNavItem from 'components/MonthNavItem/MonthNavItem';
import MonthsSkeleton from 'Insights/Subscriptions/components/Navigation/MonthsSkeleton';

const MonthsTabNav = ({ onSelectMonth, months, isLoading, onPrev, onNext, isPrevDisabled, isNextDisabled }) => (
  <div className='mx-5 d-flex pb-1'>
    <IconButton icon='icon-chevron-left' onClick={onPrev} size='lg' isDisabled={isPrevDisabled} />
    {isLoading ? (
      <MonthsSkeleton />
    ) : (
      <div className='flex-1 d-flex align-items-center justify-content-center'>
        {months.map((month) => (
          <MonthNavItem
            key={month.id}
            data={month}
            onClick={onSelectMonth}
            isActive={month.isActive}
            isDisabled={month.isDisabled}
            dateMoment={month.dateMoment}
          />
        ))}
      </div>
    )}
    <IconButton icon='icon-chevron-right' onClick={onNext} size='lg' isDisabled={isNextDisabled} />
  </div>
);

export default MonthsTabNav;
